import React from 'react';
import OwnerForm from '../components/OwnerForm';
 

function Result() {
 
    return (
      <div>
        <OwnerForm  />

       
      </div>
    );
}

export default Result;
